module.exports = __webpack_public_path__ + "static/media/Tower_Goldchest_openingV2_compressed.84a4ff46.mp4";